module.exports = __webpack_public_path__ + "img/generic1.37e14815.webp";